(function () {
  'use strict';

  function track(eventName, payload) {
    var details = Object.assign({ page_path: window.location.pathname }, payload || {});
    if (window.KootaTracking && typeof window.KootaTracking.track === 'function') {
      window.KootaTracking.track(eventName, details);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, details));
  }

  class KootaTraceDemo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.buttons = Array.from(this.querySelectorAll('[data-koota-trace-demo-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-koota-trace-preview]'));
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button.dataset.kootaTraceDemoButton));
        button.addEventListener('keydown', (event) => this.onKeydown(event, button));
      });
    }

    onKeydown(event, button) {
      var currentIndex = this.buttons.indexOf(button);
      var nextIndex = currentIndex;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.buttons.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = this.buttons.length - 1;
      else return;
      event.preventDefault();
      var nextButton = this.buttons[nextIndex];
      this.select(nextButton.dataset.kootaTraceDemoButton);
      nextButton.focus();
    }

    select(key) {
      this.buttons.forEach((button) => {
        var active = button.dataset.kootaTraceDemoButton === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.setAttribute('tabindex', active ? '0' : '-1');
      });
      this.panels.forEach((panel) => {
        var active = panel.dataset.kootaTracePreview === key;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      track('traceability_demo_select', { product_key: key });
    }
  }

  if (!customElements.get('koota-trace-demo')) {
    customElements.define('koota-trace-demo', KootaTraceDemo);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-koota-trace-action]');
    if (!link) return;
    track('traceability_app_open', {
      trace_action: link.dataset.kootaTraceAction || 'open',
      trace_mode: link.dataset.kootaTraceMode || '',
      trace_product: link.dataset.kootaTraceProduct || '',
      trace_location: link.dataset.kootaTraceLocation || ''
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var entries = Array.from(document.querySelectorAll('[data-koota-trace-impression]'));
    if (!entries.length) return;

    if (!('IntersectionObserver' in window)) {
      entries.forEach(function (entry) {
        track('traceability_entry_view', { trace_location: entry.dataset.kootaTraceImpression || '' });
      });
      return;
    }

    var observer = new IntersectionObserver(function (observations) {
      observations.forEach(function (observation) {
        if (!observation.isIntersecting) return;
        observer.unobserve(observation.target);
        track('traceability_entry_view', {
          trace_location: observation.target.dataset.kootaTraceImpression || ''
        });
      });
    }, { threshold: 0.35 });

    entries.forEach(function (entry) { observer.observe(entry); });
  });
})();
